export default __webpack_public_path__ + "static/media/cmcd_thumb.2a0da9b2.png";